import React from 'react';

import { useIntl } from 'react-intl';

import DeleteIcon from '@atlaskit/icon/core/delete';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

export const DeleteFieldRenderer = ({
	fieldName,
	deleteDescription,
}: {
	fieldName: string;
	deleteDescription?: string;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Inline space="space.100">
			<DeleteIcon
				label={formatMessage(messages.deleteIconLabel)}
				color={token('color.icon.danger')}
			/>
			<Text>
				{deleteDescription
					? deleteDescription
					: formatMessage(messages.defaultDeleteDescription, { fieldName })}
			</Text>
		</Inline>
	);
};
